"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOAD_CONFIG = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
exports.LOAD_CONFIG = { sync: web_ui_framework_1.SyncConfig.ASYNC, order: web_ui_framework_1.OrderConfig.TOP };
//# sourceMappingURL=constants.js.map